'use strict';

export { withDecay } from "./decay.js";
//# sourceMappingURL=index.js.map